import React from "react";
import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";
import { string } from "prop-types";
import Loader from "../Loader";

const EmptyScreenAlert = ({ message, showLoader }) => (
    <>
        {showLoader ? (
            <Loader />
        ) : (
            <div className="box info service-payments__no-data">
                <Image src="images/information_fill.svg" width="16px" /> <I18n id={message} />
            </div>
        )}
    </>
);

EmptyScreenAlert.propTypes = {
    message: string.isRequired,
    showLoader: string.isRequired,
};

export default EmptyScreenAlert;
